import React, {useState, useEffect} from 'react';
import { anyObject, tFilterObject, tActiveFilters, TableRow,tAppTempUnit } from '../../types/typedefinitons';
import { Trans, useTranslation } from 'react-i18next';
import i18n from '../../i18n/i18n';
import { Icon } from '@fluentui/react';

type tfinalDataStructure = {
    [resistance:string]:{
        [materialKategorie:string]:{name:string, bemerkung:string|undefined}[]
    }
}

type tCollapseSate = {
    [group:string]:boolean
}

const ResultRows:React.FC<{dataToDisplay:anyObject, selectedValues:tActiveFilters, columnDefs:anyObject[],setSelectedValues:(action:string, changedValue?:tFilterObject) => void, appTempUnit:tAppTempUnit}> = ({dataToDisplay,selectedValues,columnDefs, setSelectedValues, appTempUnit}) => {
    const [mediaInformation, setMediaInformation] = useState<tfinalDataStructure>({});
    const [isMessageAvailable, setIsMessageAvailable] = useState('');
    const [userHasToSelect, setUserHasToSelect] = useState<{data:(string|undefined)[], name:string, medium:string}>();
    const [componentDataStructure, setComponentDataStructure] = useState<tNewDataStructure>({});
    const [resultTopicString, setResultTopicString] = useState<{key?:string, data?:{}}>({});
    const [collapseState, setCollapseState] = useState<tCollapseSate>({});
    const [materialResult, setMaterialResult] = useState<{title:string, description:string, notice:{material:string,text:string}[]}>();
    const {t} = useTranslation();

    
    const filterTexts:{[key:string]:any} = {
        Konzentration: {selectionLabel:'labels.konzentrationSelection', selectedLabel:'labels.konzentrationSelected', suffix: ''},
        Temperatur: {selectionLabel:'labels.temperaturSelection', selectedLabel:'labels.temperaturSelected', suffix: appTempUnit.text}
    }

    type tMaterialStructure = {
        [key:string]: {
            [key:string]: 
                {
                    resistance:string|undefined, 
                    name:string,
                    anmerkung?:string
                }
            }
    }



    type tNewDataStructure = {
        [medium:string]: {
            data:TableRow[],
            Konzentration:(string|undefined)[],
            Temperatur: string[],
            filter:{
                    [criteria:string]:string
            }
        }
    }   


    const userFilterFunction = (data?:tNewDataStructure) => {
        let functionData = componentDataStructure;
        if(functionData){
            let shouldSkip = false;
            Object.keys(functionData).forEach((mediumKey, index) => {
                const mediumInformation = functionData![mediumKey];
            
                if(mediumInformation.Konzentration.length > 1 && !mediumInformation.filter.Konzentration && !shouldSkip){
                    setUserHasToSelect({name:'Konzentration', data:mediumInformation.Konzentration, medium:mediumKey});
                    setIsMessageAvailable(t('labels.completeMediumSelection'))
                    shouldSkip = true;
                }
                else if(mediumInformation.Konzentration.length === 1 && !mediumInformation.filter.Konzentration && !shouldSkip){
                    // setUserHasToSelect({name:'Konzentration', data:mediumInformation.Konzentration, medium:mediumKey});
                    setMediumRowFilter(mediumKey, 'Konzentration', mediumInformation.Konzentration[0]!);
                    shouldSkip = true;
                }
                else if(mediumInformation.Temperatur.length > 1 && !mediumInformation.filter.Temperatur && !shouldSkip){
                    setUserHasToSelect({name:'Temperatur', data:mediumInformation.Temperatur, medium:mediumKey});
                    setIsMessageAvailable(t('labels.completeMediumSelection'))
                    shouldSkip = true;
                }
                else if(mediumInformation.Temperatur.length === 1 && !mediumInformation.filter.Temperatur && !shouldSkip){
                    // setUserHasToSelect({name:'Temperatur', data:mediumInformation.Temperatur, medium:mediumKey});
                    setMediumRowFilter(mediumKey, 'Temperatur', mediumInformation.Temperatur[0]!);
                    shouldSkip = true;
                }
                else if(!shouldSkip){
                    setUserHasToSelect(undefined);
                    setIsMessageAvailable('');
                    if(index === Object.keys(functionData!).length -1){
                       consultedData(functionData!); 
                    }
                }
            })
        }
    }
    
    useEffect(()=>{
        const selectedValuesArray = selectedValues.medium.map(medium => medium.filterValue);
        if(dataToDisplay.length === undefined){
            dataToDisplay = Object.values(dataToDisplay)
        }
        let newDataStructure:tNewDataStructure = JSON.parse(JSON.stringify(componentDataStructure));
        // let newDataStructure:tNewDataStructure = JSON.parse(JSON.stringify(componentDataStructure)) || {};

        let newCreated = false;
        // Trennen nach verschiedenen Medien
        dataToDisplay.forEach((dataRow:TableRow)=>{
            const mediumUniqe = dataRow.Medium + (dataRow.Zustand ? ' | ' + dataRow.Zustand : '');
            if(selectedValuesArray.indexOf(mediumUniqe) !== -1){
                if(!newDataStructure[mediumUniqe]){
                    newDataStructure[mediumUniqe] = {data:[], Konzentration:[],Temperatur:[], filter:{}};
                    newCreated = true;
                }
                if(newCreated){
                    newDataStructure[mediumUniqe].data.push(dataRow);
                }

                if(dataRow.Konzentration && newDataStructure[mediumUniqe].Konzentration.indexOf(dataRow.Konzentration) === -1) newDataStructure[mediumUniqe].Konzentration.push(dataRow.Konzentration);
                if(dataRow.Temperatur && newDataStructure[mediumUniqe].Temperatur.indexOf(dataRow.Temperatur) === -1) newDataStructure[mediumUniqe].Temperatur.push(dataRow.Temperatur);
            
                newDataStructure[mediumUniqe].Konzentration.sort((a,b) => a ? a.localeCompare(b!, undefined, {numeric: true}):0); 
                newDataStructure[mediumUniqe].Temperatur.sort(); 
            }

        });

        setComponentDataStructure(newDataStructure);
        // Gegebenenfalls Daten weiter filtern
       
        

        // Medlung nur Material
        if(selectedValues.material.length > 0 && selectedValues.medium.length === 0){
            setIsMessageAvailable(t('labels.mediumMissing'));
        }
        else{
            setIsMessageAvailable('');
        }
      
    },[selectedValues.material.length, selectedValues.medium.length])
    
    useEffect(() => {
        userFilterFunction();
    },[componentDataStructure])


    const updateFilters = (mediumData:tNewDataStructure[string], criteria:string, filterValue?:string) => {
        let foundMatchKonzentration = false;
        let foundMatchTemperatur = false;
        mediumData.data.forEach((dataRow:any) => {
            if(dataRow[criteria] === filterValue || !filterValue){
                console.log('test')
                if(criteria !== 'Konzentration' && dataRow.Konzentration && (mediumData.Konzentration.indexOf(dataRow.Konzentration) === -1 || !foundMatchKonzentration)){
                    foundMatchKonzentration = true;
                    if(!foundMatchKonzentration){
                        mediumData.Konzentration = []; 
                    }
                    foundMatchKonzentration = true; 
                    if(mediumData.Konzentration.indexOf(dataRow.Konzentration) === -1) mediumData.Konzentration.push(dataRow.Konzentration);
                }
                console.log(criteria !== 'Temperatur', dataRow.Temperatur, (mediumData.Temperatur.indexOf(dataRow.Temperatur) === -1 || !foundMatchTemperatur))
                if(criteria !== 'Temperatur' && dataRow.Temperatur && (mediumData.Temperatur.indexOf(dataRow.Temperatur) === -1 || !foundMatchTemperatur)){
                    if(!foundMatchTemperatur){
                        mediumData.Temperatur = []; 
                    }
                    foundMatchTemperatur = true;
                    if(mediumData.Temperatur.indexOf(dataRow.Temperatur) === -1) mediumData.Temperatur.push(dataRow.Temperatur);
                } 
            }
        });
        return mediumData;
    }

    const setMediumRowFilter = (medium:string, criteria:string, value:string) => {
        let filterActive = componentDataStructure;
        let newData:tNewDataStructure = JSON.parse(JSON.stringify(filterActive));
        newData![medium].filter[criteria] = value;
        //Filtermöglichkeit zurücksetzen
        newData[medium] = updateFilters(newData[medium], criteria, value);
        console.log('Row Filter', newData)
        setComponentDataStructure(newData);
        // userFilterFunction(newData);
    
    }

    const removeFilter = (medium:string, criteria:string) => {
        if(criteria === 'medium'){
            setSelectedValues('remove',{filterValue:medium, filterKeys:[],resultType:'medium'});
            let data = JSON.parse(JSON.stringify(componentDataStructure));
            delete data[medium];
            setResultTopicString({});
            setMediaInformation({});
            setMaterialResult(undefined);
            setComponentDataStructure(data);
        }
        else if(criteria === 'material'){
            setSelectedValues('remove',{filterValue:medium, displayValue:medium, filterKeys:[],resultType:'material'});
            setResultTopicString({});
            setMediaInformation({});
            setMaterialResult(undefined);
        } 
        else {
            let data = componentDataStructure![medium].filter;
            delete data[criteria];
            const newData = JSON.parse(JSON.stringify(componentDataStructure));
            newData![medium].filter = data;
            newData[medium] = updateFilters(newData[medium], criteria)
            setComponentDataStructure(newData);
            setMaterialResult(undefined);
            setResultTopicString({});
            setMediaInformation({});
            // userFilterFunction(newData);
        }
       
    }

    const joinArrayToSentence = (array:(string|undefined)[]) => {
        let result = ''
        array.forEach((media, index) => {
            if(index > 0 && index < array.length-1){
                result += ', ';
            }
            else if(index > 0 && index === array.length-1){
                result += ' ' + t('singleWords.and') + ' ';
            }

            result += media 
        })
        return result;
    }

    const consultedData = (dataPerMedium:tNewDataStructure) => {

        let dataPerMaterial:tMaterialStructure = {};
        let finalData:tfinalDataStructure = {}
        let medienStrings:string[] = [];
        let bemerkungskey = '_Bemerkung' + (i18n.language === 'de-DE' ? 'DE' : 'EN');

        Object.keys(dataPerMedium).forEach(medium => {
            let mediumString = medium + (dataPerMedium[medium].filter.Konzentration ? ', ' + t('resistanceTranslations.maxKonzentration') + dataPerMedium[medium].filter.Konzentration : '') + (dataPerMedium[medium].filter.Temperatur ? ', ' + t('resistanceTranslations.maxTemperatur') + dataPerMedium[medium].filter.Temperatur + ' ' + filterTexts.Temperatur.suffix : '');
            medienStrings.push(mediumString);
            dataPerMedium[medium].data.forEach(mediumSet => {
                if((!dataPerMedium[medium].filter.Konzentration || dataPerMedium[medium].filter.Konzentration === mediumSet.Konzentration) && (!dataPerMedium[medium].filter.Temperatur || dataPerMedium[medium].filter.Temperatur === mediumSet.Temperatur)){
                    columnDefs.forEach(materialGroup =>{
                        if(materialGroup.headerName){
                            materialGroup.children.forEach((material:any) => {
                                let materialName = material.headerName + (material.headerTooltip ? ' ' + material.headerTooltip : '');
                                let materialKey = material.field;
                                let resistance = mediumSet[material.field];
                                if(!dataPerMaterial[materialGroup.headerName]){
                                    dataPerMaterial[materialGroup.headerName] = {};
                                }

                                if(!dataPerMaterial[materialGroup.headerName][materialKey]){
                                    dataPerMaterial[materialGroup.headerName][materialKey] = {resistance:undefined, name:materialName, anmerkung:undefined}
                                }
                                let currentResistance = dataPerMaterial[materialGroup.headerName][materialKey].resistance;
                                if(!currentResistance){
                                    dataPerMaterial[materialGroup.headerName][materialKey].resistance = resistance || 'kA';
                                    dataPerMaterial[materialGroup.headerName][materialKey].anmerkung = mediumSet[material.field + bemerkungskey] || '';
                                }
                                else if(currentResistance === '+' && resistance === '(+)'){
                                    dataPerMaterial[materialGroup.headerName][materialKey].resistance = resistance;
                                    dataPerMaterial[materialGroup.headerName][materialKey].anmerkung = mediumSet[material.field + bemerkungskey] || '';
                                }
                                else if((currentResistance === '+' || currentResistance === '(+)') && resistance === 'o'){
                                    dataPerMaterial[materialGroup.headerName][materialKey].resistance = resistance;
                                    dataPerMaterial[materialGroup.headerName][materialKey].anmerkung = mediumSet[material.field + bemerkungskey] || '';
                                }
                                else if((currentResistance === '+' || currentResistance === '(+)' || currentResistance === 'o') && resistance === '(o)'){
                                    dataPerMaterial[materialGroup.headerName][materialKey].resistance = resistance;
                                    dataPerMaterial[materialGroup.headerName][materialKey].anmerkung = mediumSet[material.field + bemerkungskey] || '';
                                }
                                else if((currentResistance === '+' || currentResistance === '(+)' || currentResistance === 'o' || currentResistance === '(o)') && (resistance === '(-)' || resistance === '-')){
                                    dataPerMaterial[materialGroup.headerName][materialKey].resistance = resistance;
                                    dataPerMaterial[materialGroup.headerName][materialKey].anmerkung = mediumSet[material.field + bemerkungskey] || '';
                                }
                                else if((currentResistance === '+' || currentResistance === '(+)' || currentResistance === 'o' || currentResistance === '(o)' || currentResistance === '(-)' || currentResistance === '-') && (resistance === 'kA')){
                                    dataPerMaterial[materialGroup.headerName][materialKey].resistance = resistance;
                                    dataPerMaterial[materialGroup.headerName][materialKey].anmerkung = mediumSet[material.field + bemerkungskey] || '';
                                }
                                else if((currentResistance === '+' || currentResistance === '(+)' || currentResistance === 'o' || currentResistance === '(o)' || currentResistance === '(-)' || currentResistance === '-' || currentResistance === 'kA') && (resistance === undefined)){
                                    dataPerMaterial[materialGroup.headerName][materialKey].resistance = 'kA';
                                    dataPerMaterial[materialGroup.headerName][materialKey].anmerkung = mediumSet[material.field + bemerkungskey] || '';
                                }
                            })
                        }
                    })
                }
            });
        });



        if(selectedValues.material.length === 0){
            setMaterialResult(undefined);
            Object.keys(dataPerMaterial).forEach(materialGroup => {
                Object.values(dataPerMaterial[materialGroup]).forEach(material => {
                    if(!finalData[material.resistance!]){
                        finalData[material.resistance!] = {}
                    }
                    if(!finalData[material.resistance!][materialGroup]){
                        finalData[material.resistance!][materialGroup] = [];
                    }
                    finalData[material.resistance!][materialGroup].push({name:material.name, bemerkung:material.anmerkung});
                    finalData[material.resistance!][materialGroup].sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));

                })
            })

            


            let finalMedienString = joinArrayToSentence(medienStrings);
            
           

            setResultTopicString({key:'headlines.resultHeadline',data:{media:finalMedienString}});
            console.log('mediaInformation', finalData)
            setMediaInformation(finalData)
        }
        else{
            setMaterialResult(undefined);
            setResultTopicString({});
            setMediaInformation({});
            let resistanceInformation:{resistance:(string|undefined)[], notice:{material:string, text:string}[]} = {resistance:[], notice:[]};
            selectedValues.material.forEach((materialInfo) =>{
                const materialName = materialInfo.displayValue?.replace(/\.|\//g,'');
                Object.keys(dataPerMaterial).forEach(materialGroup => {
                    if(dataPerMaterial[materialGroup][materialName!]){
                        resistanceInformation.resistance.push(dataPerMaterial[materialGroup][materialName!].resistance);
                        if(dataPerMaterial[materialGroup][materialName!].anmerkung){
                            resistanceInformation.notice.push({material:materialName!, text:dataPerMaterial[materialGroup][materialName!].anmerkung!})
                        }

                    }
                })
            });

            let kaResult = true;
            let resistanceResult = t('resistanceTranslations.resistanceResults.kA');
            let title = t('resistanceTranslations.title.kA');

            if(resistanceInformation.resistance.indexOf('+') !== -1){
                resistanceResult = t('resistanceTranslations.resistanceResults.+');
                title = t('resistanceTranslations.title.+');
                kaResult = false;
            }

            if(resistanceInformation.resistance.indexOf('(+)') !== -1){
                resistanceResult = t('resistanceTranslations.resistanceResults.(+)');
                title = t('resistanceTranslations.title.(+)');
                kaResult = false;
            }

            if(resistanceInformation.resistance.indexOf('o') !== -1){
                resistanceResult = t('resistanceTranslations.resistanceResults.o');
                title = t('resistanceTranslations.title.o');
                kaResult = false;
            }
            
            if(resistanceInformation.resistance.indexOf('(o)') !== -1){
                resistanceResult = t('resistanceTranslations.resistanceResults.(o)');
                title = t('resistanceTranslations.title.(o)');
                kaResult = false;
            }
            if(resistanceInformation.resistance.indexOf('(-)') !== -1){
                resistanceResult = t('resistanceTranslations.resistanceResults.(-)');
                title = t('resistanceTranslations.title.(-)');
                kaResult = false;
            }
            if(resistanceInformation.resistance.indexOf('-') !== -1){
                resistanceResult = t('resistanceTranslations.resistanceResults.-');
                title = t('resistanceTranslations.title.-');
                kaResult = false;
            }
            if(resistanceInformation.resistance.indexOf('kA') !== -1){
                resistanceResult = t('resistanceTranslations.resistanceResults.kA');
                title = t('resistanceTranslations.title.kA');
                kaResult = true;
            }
            
            const joinedMaterials = joinArrayToSentence(selectedValues.material.map(materialInfo => materialInfo.displayValue));
            const joinedMedia = joinArrayToSentence(medienStrings);
            let description = t('resistanceTranslations.description.default', {count:resistanceInformation.resistance.length, materials:joinedMaterials, mediadata: joinedMedia, mediumCount:medienStrings.length, resistanceValue:resistanceResult });
            if(kaResult){
                description = t('resistanceTranslations.description.ka',{count:resistanceInformation.resistance.length, materials:joinedMaterials, mediadata: joinedMedia, mediumCount:medienStrings.length})
            }


            setMaterialResult({title:title, description:description, notice:resistanceInformation.notice})
        }
    }

    const handleListCollapse = (group:string) => {
        let newObject = JSON.parse(JSON.stringify(collapseState));
        newObject[group] = !newObject[group];
        setCollapseState(newObject); 
    }

    if(selectedValues.medium.length > 0 || selectedValues.material.length > 0){
        return(
            <>
            <div>
            {
                componentDataStructure ? Object.keys(componentDataStructure).map(medium => {
                    return (
                        <>
                        <div className="gemu-rs-medium-definition-group">
                        <span  onClick={() => removeFilter(medium, 'medium')} className="gemu-rs-filter-element removable">{medium}</span>
                        {Object.keys(componentDataStructure[medium].filter).map(criteria => {
                            return(
                                <span className={'gemu-rs-filter-element ' + (componentDataStructure[medium][criteria as 'Konzentration'|'Temperatur'].length > 1 ? 'removable' : '')} onClick={() => removeFilter(medium, criteria)}>{componentDataStructure[medium].filter[criteria]} {filterTexts[criteria].suffix}</span>
                            )
                        })
                        }
                        </div>
                        </>
                    )
                }): null
            }
            {
                selectedValues.material ? 
                    selectedValues.material.map((material) =>{
                        return(
                            <div className="gemu-rs-medium-definition-group">
                                 <span className={'gemu-rs-filter-element removable'} onClick={() => removeFilter(material.displayValue!, 'material')}>{material.displayValue}</span>
                            </div>
                        )
                    })
                : null
            }
            </div>
            {userHasToSelect ? 
                <div className="gemu-rs-set-more-filter-row">
                <span className="gemu-rs-set-more-filter-label">{t(filterTexts[userHasToSelect.name].selectionLabel, {medium:userHasToSelect.medium})}  </span>
                {userHasToSelect.data.map((selectionValue, selectionIndex) => {
                    return(
                           <span key={'si-'+selectionIndex} className="gemu-rs-filter-element clickable" onClick={() => setMediumRowFilter(userHasToSelect.medium, userHasToSelect.name, selectionValue!)}>{selectionValue} {filterTexts[userHasToSelect.name!].suffix}</span>
                    )
                })
                }
                </div>
                :
                null
            }
            {
                materialResult ? 
                <>
                <h2 className="gemu-rs-result-headline">{materialResult.title}</h2>
                <p>{materialResult.description}</p>
                {materialResult.notice.map(notice => {
                    return(
                       <>
                       <p><b>{notice.material}</b>{notice.text}</p>
                       </> 
                    )
                })}
                </>
                :
                null
            }
            <h2 className="gemu-rs-result-headline">{t(resultTopicString.key!,resultTopicString.data)}</h2>
            {mediaInformation && Object.keys(mediaInformation).length > 0 ? 
            <>
            {
            mediaInformation['+'] ? 
            <CollapsibleGroup        
                title={t('resistanceKeys.+')}
                data={mediaInformation['+']}
                group="+"
                handleCollapse={handleListCollapse}
                collapseState={collapseState}
            />
            : null}
            {
            mediaInformation['(+)'] ? 
            <CollapsibleGroup        
                title={t('resistanceKeys.(+)')}
                data={mediaInformation['(+)']}
                group="(+)"
                handleCollapse={handleListCollapse}
                collapseState={collapseState}
                hint={true} 
            />
            : null}
            {
            mediaInformation['o'] ? 
            <CollapsibleGroup        
                title={t('resistanceKeys.o')}
                data={mediaInformation['o']}
                group="o"
                handleCollapse={handleListCollapse}
                collapseState={collapseState}
            />
            : null}
            {
            mediaInformation['(o)'] ? 
            <CollapsibleGroup        
                title={t('resistanceKeys.(o)')}
                data={mediaInformation['(o)']}
                group="(o)"
                handleCollapse={handleListCollapse}
                collapseState={collapseState}
                hint={true}
            />
            : null}
            {
            mediaInformation['-'] ? 
            <CollapsibleGroup        
                title={t('resistanceKeys.-')}
                data={mediaInformation['-']}
                group="-"
                handleCollapse={handleListCollapse}
                collapseState={collapseState}
            />
            : null}
            {
            mediaInformation['(-)'] ? 
            <CollapsibleGroup        
                title={t('resistanceKeys.(-)')}
                data={mediaInformation['(-)']}
                group="(-)"
                handleCollapse={handleListCollapse}
                collapseState={collapseState}
                hint={true}
            />
            : null}
            </>
            :
            <>
            {isMessageAvailable ? <h2 className="gemu-rs-result-headline">{isMessageAvailable}</h2> : null}
            </>
            }
            </>
        )
    }
    else{
        return null;
    }
}

const CollapsibleGroup:React.FC<{title:string, data:{[materialKategorie:string]:{name:string, bemerkung?:string}[]},handleCollapse:(group:string)=>void, group:string, collapseState:tCollapseSate, hint?:boolean}> = ({title, data, handleCollapse, group, collapseState, hint}) => {
    const {t} = useTranslation();
    return (
        <>
        <div className={'gemu-rs-collapsible-section-headline ' + (collapseState[group] ? 'active':'')} onClick={()=>{handleCollapse(group)}}>
            <span>{title}</span>
        </div>
        <div className={'gemu-rs-collapsible-section-container ' + (collapseState[group] ? 'active':'')}>
        {hint ? <div className='gemu-rs-category-hint'><Icon iconName='Info'/><span>{t('infoText.hintLimitations')}</span></div> : null }
        {Object.keys(data).map(materialGroup => {
            return (
                <>
                    <h3 className="gemu-rs-material-group-headline">{materialGroup}</h3>
                    <div className="gemu-rs-result-list">
                        {data[materialGroup].map(material => {
                            return (
                                <div key={material.name}>
                                    <span className="gemue-rs-result-list-medium">
                                    {material.name}
                                    </span>
                                    {material.bemerkung ? <span className="gemu-rs-result-list-notice">{material.bemerkung}</span> : null}
                                </div>
                            )
                        })
                        }
                    </div>
                </>
            )
        })}
        </div>
        </>
    )
}

export default ResultRows